import React from 'react'
import { connect } from 'react-redux'
import { Project } from '@leverege/api-redux'
import { Dialogs, Content, Button, Flex, Text, Toast } from '@leverege/ui-elements'
import { EditUserRolesDialog } from '@leverege/api-ui-user-management'
import PatchOps from '@leverege/api-patch-ops'

import { ProjectActions, DeviceActions, ApiAccessUpdater, ApiAccessActions } from '~/actions'

import { YesNoDialog } from '~/views'
import ApiAccessItem from './ApiAccessItem'

import style from './apiAccess.css'

class ApiAccessScreen extends React.Component {

  constructor( props ) {
    super( props )
    this.state = { 
      showRemoveDialog : false, 
      removeApiAccess : null, 
    }
  }

  componentDidMount() {
    const { dispatch, match } = this.props 
    dispatch( ApiAccessActions.list( match.params.projectId ) )
  }
  
  onEvent = async ( event ) => {
    const { history, dispatch, match } = this.props

    if ( event.type === ApiAccessItem.ACTIVATE_EVENT ) {
      await dispatch( ApiAccessActions.update(
        match.params.projectId,
        event.target.id,
        PatchOps( 'active', true ).ops()
      ) )
      Toast.success( [ 'Api Access Key Enabled' ] )
    } else if ( event.type === ApiAccessItem.DEACTIVATE_EVENT ) {
      await dispatch( ApiAccessActions.update(
        match.params.projectId,
        event.target.id,
        PatchOps( 'active', false ).ops()
      ) )
      Toast.success( [ 'Api Access Key Disabled' ] )

    } else if ( event.type === ApiAccessItem.RENAME_EVENT ) {
      await dispatch( ApiAccessActions.update(
        match.params.projectId,
        event.target.id,
        PatchOps( 'name', event.value ).ops()
      ) )
      Toast.success( [ 'Api Access Key Renamed' ] )
    } else if ( event.type === ApiAccessItem.REMOVE_EVENT ) {
      this.setState( { showRemoveDialog : true, removeApiAccess : event.target } )
    } else if ( event.type === ApiAccessItem.ROLES_EVENT ) {
      const apiAccess = event.target
      Dialogs.show( {
        component : EditUserRolesDialog,
        props : {
          user : apiAccess,
          actions : Project( apiAccess.projectId ),
          // user, roles : user.roles || [], edit : true, clientProps : this.props, selectorProps, actions, 
          projectId : apiAccess.projectId,
        }
      } )
    } else if ( event.type === ApiAccessItem.GO_TO_EVENT ) {
      if ( event.target.resourceType === 'system' ) {
        history.push( `/project/${event.target.projectId}/system/${event.target.resourceId}` )
      } else if ( event.target.resourceType === 'device' ) {
        dispatch( DeviceActions.getDevice( undefined, event.target.resourceId ) )
          .then( ( device ) => {
            history.push( `/project/${event.target.projectId}/system/${device.systemId}/device/${event.target.resourceId}` )
          } )
      }
    }
  }

  onCreateApiAccess() {
    const { dispatch, match } = this.props
    return dispatch( ApiAccessActions.create(
      match.params.projectId,
      {},
    ) )
  }
  
  onPromptRemoveYes = async () => {
    const { dispatch, match } = this.props
    const { removeApiAccess } = this.state
    await dispatch( ApiAccessActions.delete(
      match.params.projectId,
      removeApiAccess.id,
    ) )
    this.setState( { showRemoveDialog : false, removeApiAccess : null } )
  }

  onPromptRemoveNo = () => {
    this.setState( { showRemoveDialog : false, removeApiAccess : null } )
  }

  render() {
    const { removeApiAccess, showRemoveDialog } = this.state
    const { apiAccess } = this.props 

    return (
      <Content>

        <Content.Header className={style.header}>
          <Flex className={style.headerRow} direction="row" justify="space-between">
            <Text variant="screenTitle">API Access Keys</Text>
            <Button onClick={() => this.onCreateApiAccess()}> 
              <i className="fa fa-fw fa-circle-plus fa-lg" />
              {' '}
              New Access Key
            </Button>
          </Flex>
        </Content.Header>

        <Content.Area>
          {apiAccess?.items?.map?.( ( apiAccess ) => {
            return (
              <ApiAccessItem key={apiAccess.id} item={apiAccess} onEvent={this.onEvent} />
            )
          } )}
          <YesNoDialog
            show={showRemoveDialog} 
            title={`Delete ${removeApiAccess?.name}?`}
            message={<div>Are you sure you want to permanently delete this API Access Key?</div>}
            onYes={this.onPromptRemoveYes}
            onNo={this.onPromptRemoveNo} /> 
        </Content.Area>

      </Content>
    )
  }
}

export default connect(
  state => ( {
    project : state.project,
    apiAccess : state.apiAccess,
  } )
)( ApiAccessScreen )
